import { VisibleEnum, BrandsEnum } from 'types';
import * as yup from 'yup';

export const initialFormState = {
  titleAm: '',
  titleEn: '',
  titleRu: '',
  category: [],
  images: {} as FileList,
  pdf: {} as FileList,
  visible: VisibleEnum.YES,
}

function returnImageYup(messag = 'Upload image is required') {
  return yup.mixed()
    .test(
      'is-files-length',
      messag,
      (value) => Object.keys(value || {}).length !== 0
    )
    .test(
      'is-files-length',
      'You can upload maximum 1 file',
      (value) => Object.keys(value || {}).length <= 5
    )
}

export const createCertificateSchema = yup.object().shape({
  titleAm: yup.string().required('Title is required.'),
  titleEn: yup.string().required('Title is required.'),
  titleRu: yup.string().required('Title is required.'),
  images: returnImageYup('You can upload only one picture'),
  pdf: returnImageYup('You can upload only one pdf file'),
  category:
  yup.array().of(yup.string().required('Category is required.'))
    .min(1, "You must select at least one category"),
  visible: yup.string().required(),
});

export const updateCertificateSchema = yup.object().shape({
  titleAm: yup.string().required('Title is required.'),
  titleEn: yup.string().required('Title is required.'),
  titleRu: yup.string().required('Title is required.'),
  category:
  yup.array().of(yup.string().required('Category is required.'))
    .min(1, "You must select at least one category"),
  visible: yup.string().required(),
});
